import Plot from 'react-plotly.js'
import { Data } from 'plotly.js'

interface HeatmapChartProps {
  data: number[][]
  xLabels: string[]
  yLabels: string[]
  title?: string
  height?: number
  colorScale?: 'RdYlGn' | 'Blues' | 'Viridis' | 'Hot'
  showValues?: boolean
  className?: string
}

export default function HeatmapChart({
  data,
  xLabels,
  yLabels,
  title,
  height = 400,
  colorScale = 'RdYlGn',
  showValues = true,
  className
}: HeatmapChartProps) {
  const trace: Data = {
    z: data,
    x: xLabels,
    y: yLabels,
    type: 'heatmap',
    colorscale: colorScale,
    showscale: true,
    hoverongaps: false,
    hovertemplate: showValues ? '%{z:.2f}<extra></extra>' : undefined,
    colorbar: {
      tickfont: { color: '#94a3b8', size: 10 },
      thickness: 15
    }
  } as Data

  const layout = {
    title: title ? {
      text: title,
      font: { color: '#e2e8f0', size: 14 }
    } : undefined,
    height,
    margin: { t: title ? 40 : 20, r: 60, b: 60, l: 80 },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    font: { color: '#94a3b8', family: 'Inter, sans-serif' },
    xaxis: {
      tickangle: -45,
      tickfont: { size: 10 },
      side: 'bottom' as const
    },
    yaxis: {
      tickfont: { size: 10 },
      autorange: 'reversed' as const
    }
  }

  const config = {
    displayModeBar: false,
    responsive: true
  }

  return (
    <div className={className}>
      <Plot
        data={[trace]}
        layout={layout}
        config={config}
        style={{ width: '100%' }}
      />
    </div>
  )
}
